export default "__VITE_ASSET__CatEbmsB__"